import React from 'react'
import { get, flowRight } from 'lodash'
import { withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { scrollTop } from 'lib/helpers'
import { scrollTargetVar } from 'lib/utils/store/cache'

class LocationScroll extends React.Component {
    componentDidMount () {
        this.update()
    }

    componentDidUpdate (prevProps) {
        const { location, history } = this.props
        const noScrollOnPathChange = get(location, 'state.locationScroll.noScrollOnPathChange', false)

        if (location.pathname !== prevProps.location.pathname && !noScrollOnPathChange) {
            scrollTop()
            scrollTargetVar(null)
        }

        if (noScrollOnPathChange) {
            history.replace({
                ...location,
                state: {
                    ...location.state,
                    locationScroll: null,
                },
            })
        }

        this.update()
    }

    update () {
        const { location, history } = this.props

        const scrollTargetName = get(location, 'state.scrollTarget.name', false)
        if (scrollTargetName) {
            scrollTargetVar({ name: scrollTargetName })

            history.replace({
                ...location,
                state: {
                    ...location.state,
                    scrollTarget: null,
                },
            })
        }
    }

    render () {
        return null
    }
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
)(LocationScroll)
